<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.edit_mixer' | translate }}
    v-card-content
      v-input.mb-3(
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="currentMixer.name")
      .cols-x
        .cols-x__2
          v-input.mb-3(
            :label="$t('base.capacity_from')"
            :hint="errorMessage('min_weight')"
            :invalid="!!errorMessage('min_weight')"
            @input="clearError('min_weight')"
            v-model="currentMixer.min_weight")
        .cols-x__2
          v-input.mb-3(
            :label="$t('base.capacity_to')"
            :hint="errorMessage('max_weight')"
            :invalid="!!errorMessage('max_weight')"
            @input="clearError('max_weight')"
            v-model="currentMixer.max_weight")
      v-select.mb-3(
        item-name="label"
        item-value="value"
        :options="options"
        :label="$t('base.automatic_transition_time')"
        v-model="currentMixer.skip_time")
      v-switch.mb-3(
        :label="$t('base.weight_up')"
        v-model="currentMixer.up_down")
      //- v-switch.mb-3(
      //-   :label="$t('base.rounding')"
      //-   v-model="currentMixer.rounding")
      //- v-range(
      //-   :max="100"
      //-   :label="$t('reports.auger_rotations')"
      //-   v-model="currentMixer.auger_rotations")
      //- v-range(
      //-   :max="100"
      //-   :label="$t('reports.auger_rotations_coefficient')"
      //-   v-model="currentMixer.auger_rotations_coefficient")
      //- v-range(
      //-   :min="90"
      //-   :label="$t('base.download_admittance')"
      //-   v-model="currentMixer.loading.admittance")
      //- v-range(
      //-   :label="$t('base.download_sensitivity')"
      //-   v-model="currentMixer.loading.sensitivity")
      //- v-range(
      //-   :label="$t('base.unloading_admittance')"
      //-   :min="90"
      //-   v-model="currentMixer.unloading.admittance")
      //- v-range(
      //-   :label="$t('base.unloading_sensitivity')"
      //-   v-model="currentMixer.unloading.sensitivity")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        @click="onSave")
        | {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'EditModal',
  mixins: [formErrorsMixin],
  components: {
    DeleteBtn
  },

  data: (vm) => ({
    errors: {
      name: null,
      min_weight: null,
      max_weight: null
    },
    options: [
      { id: 0, label: 'base._turn_off', value: null },
      { id: 1, label: `3 ${vm.$t('base.s')}`, value: '3' },
      { id: 2, label: `5 ${vm.$t('base.s')}`, value: '5' },
      { id: 3, label: `7 ${vm.$t('base.s')}`, value: '7' },
      { id: 4, label: `10 ${vm.$t('base.s')}`, value: '10' }
    ],
    loading: false
  }),

  methods: {
    ...mapActions('mixers', [
      'saveChanges',
      'deleteMixer'
    ]),

    async onSave () {
      const { id, ...payload } = this.currentMixer
      if (!this.checkValidData()) return
      this.loading = true

      const { errors } = await api.mixers.updateById(id, payload)
      this.errors = errors
      if (!errors) {
        await this.saveChanges()
      }
      this.loading = false
    },
    checkValidData () {
      let valid = true
      this.errors.name = null
      this.errors.min_weight = null
      this.errors.max_weight = null

      const minWeight = Number(this.currentMixer.min_weight)
      const maxWeight = Number(this.currentMixer.max_weight)

      if (!this.currentMixer.name) {
        this.errors.name = this.errors.name = ['3']
        valid = false
      } else if (this.currentMixer.name.length > 30) {
        this.errors.name = this.errors.name = ['6', 30]
        valid = false
      }

      if (this.currentMixer.min_weight === null || isNaN(minWeight) || minWeight < 0) {
        this.errors.min_weight = ['9']
        valid = false
      }

      if (this.currentMixer.max_weight === null || isNaN(maxWeight) || maxWeight < 0) {
        this.errors.max_weight = ['9']
        valid = false
      }

      if (minWeight > maxWeight) {
        this.errors.min_weight = ['8']
        valid = false
      }

      if (minWeight < 1) {
        this.errors.min_weight = ['min_val', 1]
        valid = false
      }

      return valid
    },

    onDelete () {
      this.deleteMixer()
    }
  },

  computed: {
    ...mapGetters('mixers', [
      'currentMixer'
    ])
  }
}
</script>
